import React, { useState, useEffect, useRef } from "react";
import "./css/CardList2.css"; // Add this CSS file

const JobCarousel = ({ jobPositions }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % jobPositions.length);
    resetInterval();
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + jobPositions.length) % jobPositions.length
    );
    resetInterval();
  };

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(nextSlide, 4000);
  };

  useEffect(() => {
    resetInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  // Show only ONE job
  const visibleJob = jobPositions[currentIndex];

  return (
    <div className="carousel-wrapper">
      <button className="arrow left" onClick={prevSlide}>
        &#10094;
      </button>

      <div className="carousel-container">
        <div className="card-item">
          <div className="card2">
            <img
              src={visibleJob.image}
              alt={visibleJob.title}
              className="card-image-intern"
            />
            <h3 className="card-title">{visibleJob.title}</h3>
            <p className="card-details">Other details</p>
            <button
              className="apply-button"
              onClick={() =>
                window.open(
                  "https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform",
                  "_blank"
                )
              }
            >
              APPLY
            </button>
          </div>
        </div>
      </div>

      <button className="arrow right" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default JobCarousel;
